var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "updateVehicleModal",
        size: "md",
        "content-class": "sub-menu-bg-blue-transparent uv-modal",
        title: "Update Vehicle",
        "hide-footer": "",
        "no-fade": "",
        "header-close-variant": "light",
      },
    },
    [
      _c("div", { staticClass: "uv-body" }, [
        _vm.originalName
          ? _c("div", { staticClass: "uv-info-strip" }, [
              _c("span", { staticClass: "uv-info-label" }, [_vm._v("Editing")]),
              _vm._v(" "),
              _c("span", { staticClass: "uv-info-value" }, [
                _vm._v(_vm._s(_vm.originalName)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "uv-field" },
          [
            _c("label", { staticClass: "uv-label" }, [_vm._v("Vehicle Name")]),
            _vm._v(" "),
            _c("b-form-input", {
              attrs: {
                placeholder: "Enter vehicle name...",
                autocomplete: "off",
              },
              model: {
                value: _vm.form.vehicle_name,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "vehicle_name", $$v)
                },
                expression: "form.vehicle_name",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "uv-field" }, [
          _c("label", { staticClass: "uv-label" }, [_vm._v("Region")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "uv-region-grid" },
            _vm._l(_vm.regionOptions, function (r) {
              return _c(
                "button",
                {
                  key: r.extent_id,
                  staticClass: "uv-region-chip",
                  class: { selected: _vm.form.region == r },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.form.region = r
                    },
                  },
                },
                [_vm._v("\n          " + _vm._s(r.region_name) + "\n        ")]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "uv-actions" },
          [
            _c(
              "b-button",
              {
                attrs: { variant: "primary", disabled: !_vm.isValid },
                on: {
                  click: function ($event) {
                    return _vm.submit()
                  },
                },
              },
              [_vm._v("\n        Save Changes\n      ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }